import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import LandingHeader from '../landing-page/components/LandingHeader';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';
import FAQSection from './components/FAQSection';
import Footer from '../../components/Footer';

export default function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact Us — SkillBinder Support</title>
        <meta 
          name="description" 
          content="Get help with SkillBinder. Contact our support team for questions about career guidance, technical issues, billing, and more." 
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <LandingHeader />
        
        <main className="py-12">
          <div className="mx-auto max-w-6xl px-4 md:px-6">
            {/* Page Header */}
            <div className="text-center mb-12">
              <h1 className="text-4xl font-semibold text-foreground mb-4">
                How can we help you?
              </h1>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Whether you need support, have a business inquiry, or want to share feedback, 
                we're here to help you succeed in your career journey.
              </p>
              <nav className="mt-6">
                <Link 
                  to="/" 
                  className="text-primary hover:underline"
                >
                  ← Back to Home
                </Link>
              </nav>
            </div>

            {/* Main Content Grid */}
            <div className="grid lg:grid-cols-3 gap-8">
              {/* Contact Form - Takes 2 columns on large screens */}
              <div className="lg:col-span-2">
                <ContactForm />
              </div>

              {/* Contact Info Sidebar */}
              <div className="lg:col-span-1">
                <ContactInfo />
              </div>
            </div>

            {/* FAQ Section - Full Width */}
            <div className="mt-12">
              <FAQSection />
            </div>
          </div>
        </main>

        <Footer 
          privacyUrl="/privacy-policy" 
          termsUrl="/terms-of-service" 
          contactUrl="/contact-page" 
        />
      </div>
    </>
  );
}